/**
 * 🧍 **How big a person is** — T173. **Pure numbers, no `three`.**
 *
 * 🔴 **It is its own file so the sample sheet and the game read the SAME
 * numbers.** ⚠️ *A design preview that redraws the thing is a second copy of the
 * decision*, and this repo has the fault written down twice: a signpost sheet
 * with its own copy of the drawing could not have caught the bug in the picture
 * haugur approved. `players.ts` imports `three/webgpu`, which a node tool cannot
 * load — so the numbers live here and both sides import them.
 *
 * ⬜ **A STAND-IN.** 🎯 haugur has chosen a **photographed 3D model, like the
 * turf house**. What must survive that change is the one thing the wire promises:
 * **the position is the FEET.**
 */

/**
 * 📏 **How tall a stand-in person is, in metres**, and how they are built.
 *
 * ⚠️ **A body, not a portrait.** The eye is at 1.7 m (`EYE_HEIGHT`), so a
 * 1.8 m figure puts a head where a head belongs when two people stand facing
 * each other. 🎯 **The photographed model replaces these numbers**, and the
 * only thing that has to survive it is that **`y` is the FEET**.
 */
export const BODY = {
  /** Shoulder to shoulder. */
  width: 0.55,
  /** Front to back — thinner than it is wide, which is what reads as a person. */
  depth: 0.3,
  /** Floor to neck. */
  torsoHeight: 1.35,
  /** A cube, and the top of it is the top of the person. */
  headSize: 0.45,
} as const;

/** Torso and head, so a stand-in reads as somebody rather than as a crate. */
export const TORSO_COLOUR = 0x6b5b7b;
export const HEAD_COLOUR = 0xc9a88a;
